module.exports = __webpack_public_path__ + "img/rog_cetra_core.ba2d0499.jpg";